<template>
  <div id="app">
    <Header />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background:transparent;
}
a.white {
color: #c0504d;
}
a.white:hover {
color: white;
}
body {
  background-color: #77933c !important;     
  margin: 0;
  padding: 0;
}

/* #77933c */

.page {
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: 50%;
  background-position-y: 50%;
  height: 100%;
  width: 100%;
  display: flex;
  overflow-y: auto;
  font-size: 16px;
}

.locations-white {
  background: rgba(255, 255, 255, .8);
  border: 1px black solid;
  color: black;
}

.locations-green {
  background: rgba(119,147,60,.8);
  color: white;
  margin-bottom: 20px;
}

.locations-grey {
  background: rgba(82, 86, 89, .8);
  color: white;
}

.locations-generic {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  width: 400px;
  max-width: 90%;
}
.locations-title {
  font-size: 28px;
  text-transform: uppercase;
  font-weight: 700;
  text-align: center;
}
h3 {
  font-family: 'Merriweather', serif;  
}
.centered-box {
  width: 75%;
  align-self: center;
}
@media screen and (max-width: 768px) {
  .centered-box {
    width: 90%;
  }
}
</style>
